import React, { useEffect, useState } from 'react'
import { Button, notification } from 'antd'
import { CopyToClipboard } from 'react-copy-to-clipboard/lib/Component'
import { BgColorsOutlined, ToTopOutlined } from '@ant-design/icons'
import { useCurrentTheme } from '../../../../../hooks/useCurrentTheme'
import styles from './Presets.module.scss'
import { useComponentLocale } from '../../../../../hooks/useComponentLocale'

function ExportColors() {
	const theme = useCurrentTheme()
	const [exportedText, setExportedText] = useState('')
	const exportedData = {}

	const getLocale = useComponentLocale()

	const copiedSuccessfullyLocale = getLocale({ component: 'common', section: 'copied_successfully' })
	const copiedToClipBoardLocale = getLocale({ component: 'common', section: 'preset_is_copied_to_clipboard' })

	const exportLocale = getLocale({ component: 'common_buttons', section: 'export' })

	const createDataForExport = (settings) => {
		Object.entries(settings).forEach(([key, value]) => {
			if (
				typeof value === 'string' ||
				Array.isArray(value) ||
				typeof value === 'number' ||
				typeof value === 'boolean'
			) {
				exportedData[key] = value
			} else if (key !== 'hotkeys') {
				createDataForExport(value)
			}
		})
	}

	const openNotification = () => {
		notification.info({
			message: `${copiedSuccessfullyLocale}`,
			description: copiedToClipBoardLocale,
			placement: 'bottomLeft',
			icon: <BgColorsOutlined />,
			duration: 3,
		})
	}

	const handleExportColor = () => {
		createDataForExport(theme)
		setExportedText(JSON.stringify(exportedData))
		openNotification()
	}

	useEffect(() => {
		createDataForExport(theme)
		setExportedText(JSON.stringify(exportedData))
	}, [exportedData])

	return (
		<CopyToClipboard text={exportedText}>
			<Button onClick={handleExportColor} className={styles.presetsButton} size='small'>
				{exportLocale}
				{/* <ToTopOutlined /> */}
			</Button>
		</CopyToClipboard>
	)
}

export default ExportColors
